export const translationEngDefault = {
  SkhemataFaqPost: {
    "backToFaq": "Back to FAQ",
    "tags": "Tags",
    "categories": "Categories"
  }
};